import Utils from '../../modules/utils'

const saveCost = (cadId, cost, callbackFunc) => {
  const url = 'cost'
  const data = {cadId, cost}
  Utils.post(url, data, callbackFunc)
}

export {saveCost}
